module.exports = __webpack_public_path__ + "img/dataimage.a479e5a7.svg";